/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BranchAddRequestDto { 
    name: string;
    address?: string | null;
    code?: string | null;
    regionName: string;
    districtName: string;
    wardName?: string | null;
    numberOfEmployees?: number | null;
    id?: number | null;
}

